import React from "react";
import Navbar from "../components/shared/navbar";
import Footer from "../components/shared/footer";
import AccBanner from "../components/accomplishment/accBanner";
import Location from "../components/accomplishment/location";
import DevNConst from "../components/accomplishment/devNConst";


const Accomplish = () => {
  return (
  <>
  <Navbar/>
  <AccBanner/>
 <Location/>
   <DevNConst/> 
<Footer/>
  </>
  )
}

export default Accomplish;